import exchangeApi from '../../api/exchange-api';
const EXCHANGE_GRAPH_SET_CURRENCIES = 'EXCHANGE_GRAPH_SET_CURRENCIES';
const EXCHANGE_GRAPH_SET_RATE_TYPES = 'EXCHANGE_GRAPH_SET_RATE_TYPES';
const EXCHANGE_GRAPH_SET_FROM = 'EXCHANGE_GRAPH_SET_FROM';
const EXCHANGE_GRAPH_SET_TO = 'EXCHANGE_GRAPH_SET_TO';
const EXCHANGE_GRAPH_SET_SELECTED_CURRENCY = 'EXCHANGE_GRAPH_SET_SELECTED_CURRENCY';
const EXCHANGE_GRAPH_SET_RATE_TYPE = 'EXCHANGE_GRAPH_SET_RATE_TYPE';
const EXCHANGE_GRAPH_GET_GRAPH_DATA_REQUEST = 'EXCHANGE_GRAPH_GET_GRAPH_DATA_REQUEST';
const EXCHANGE_GRAPH_GET_GRAPH_DATA_SUCCESS = 'EXCHANGE_GRAPH_GET_GRAPH_DATA_SUCCESS';
const EXCHANGE_GRAPH_TECHNICAL_FAILURE = 'EXCHANGE_GRAPH_TECHNICAL_FAILURE';

const exchangeGraphState = {
	loading: false,
	technicalError: false,
	selectedCurrency: null,
	currencies: [],
	results: [],
	rateTypes: [],
	rateType: null,
	from: null,
	to: null
};

const exchangeGraphGetters = {
	currencyWithName(state) {
		let selectedCurrencyWithName;
		if (state.currencies && state.currencies.currencies && state.currencies.currencies.length) {
			selectedCurrencyWithName = state.currencies.currencies.find((item) => item.currencyCode == state.selectedCurrency);
		}
		return selectedCurrencyWithName;
	}
};
const exchangeGraphActions = {
	getCurrencies({ commit }) {
		exchangeApi
			.getCurrencies()
			.then((response) => {
				response.data.currencies = response.data.currencies.filter((item) => item.currencyCode != 'HUF');
				commit(EXCHANGE_GRAPH_SET_CURRENCIES, response.data);
			})
			.catch(() => {
				commit(EXCHANGE_GRAPH_TECHNICAL_FAILURE);
			});
	},
	getTypes({ commit }, model) {
		exchangeApi
			.getTypes(model)
			.then((response) => {
				commit(EXCHANGE_GRAPH_SET_RATE_TYPES, response.data);
			})
			.catch(() => {
				commit(EXCHANGE_GRAPH_TECHNICAL_FAILURE);
			});
	},
	setRateType({ commit }, rateType) {
		commit(EXCHANGE_GRAPH_SET_RATE_TYPE, rateType);
	},
	setFrom({ commit }, from) {
		commit(EXCHANGE_GRAPH_SET_FROM, from);
	},
	setTo({ commit }, to) {
		commit(EXCHANGE_GRAPH_SET_TO, to);
	},
	setSelectedCurrency({ commit }, currency) {
		commit(EXCHANGE_GRAPH_SET_SELECTED_CURRENCY, currency);
	},
	getGraphData({ commit }, model) {
		const types = [
			'middleRate',
			'currencyBuyingRate',
			'currencySellingRate',
			'chequeBuyingRate',
			'chequeSellingRate',
			'foreignExchangeBuyingRate',
			'foreignExchangeSellingRate'
		];
		commit(EXCHANGE_GRAPH_GET_GRAPH_DATA_REQUEST);
		exchangeApi
			.getGraphData(model)
			.then((response) => {
				let results = {};
				for (let row of response.data) {
					for (let type of types) {
						if (!results[type]) {
							results[type] = [];
						}
						results[type].push([new Date(row.validityDate).getTime(), row[type]]);
					}
				}
				if (response.data.length) {
					results.currencyCode = response.data[0].currencyCode;
				}
				commit(EXCHANGE_GRAPH_GET_GRAPH_DATA_SUCCESS, results);
			})
			.catch(() => {
				commit(EXCHANGE_GRAPH_TECHNICAL_FAILURE);
			});
	}
};

const exchangeGraphMutations = {
	[EXCHANGE_GRAPH_TECHNICAL_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[EXCHANGE_GRAPH_SET_FROM](state, from) {
		state.from = from;
	},
	[EXCHANGE_GRAPH_SET_SELECTED_CURRENCY](state, selectedCurrency) {
		state.selectedCurrency = selectedCurrency;
	},
	[EXCHANGE_GRAPH_SET_TO](state, to) {
		state.to = to;
	},
	[EXCHANGE_GRAPH_GET_GRAPH_DATA_SUCCESS](state, results) {
		state.results = results;
	},
	[EXCHANGE_GRAPH_GET_GRAPH_DATA_REQUEST](state) {
		state.loading = true;
	},
	[EXCHANGE_GRAPH_SET_CURRENCIES](state, currencies) {
		state.currencies = currencies;
	},
	[EXCHANGE_GRAPH_SET_RATE_TYPES](state, rateTypes) {
		state.rateTypes = rateTypes;
	},
	[EXCHANGE_GRAPH_SET_RATE_TYPE](state, rateType) {
		state.rateType = rateType;
	}
};

export default {
	namespaced: true,
	state: exchangeGraphState,
	getters: exchangeGraphGetters,
	mutations: exchangeGraphMutations,
	actions: exchangeGraphActions
};
